module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_06-93dbf0ccf215f5805a9ca3eb50610de0.jpg";